import * as React from 'react'
import { ReactElement } from 'react'
import useEntity from '../../hooks/useEntity'
import EntityCombobox from '../Combobox/EntityCombobox'
import { EntityComboboxProps } from './EntityCombobox'

export type AuthorizationGroupDto = {
    id: string
    name: string
}

type Props = Partial<EntityComboboxProps<AuthorizationGroupDto>> &
    Required<Pick<EntityComboboxProps<AuthorizationGroupDto>, 'selectedOptions' | 'onOptionSelect'>>

export default function AuthorizationGroupCombobox(props: Props): ReactElement {
    const [groups] = useEntity<AuthorizationGroupDto[]>(
        () => ({
            method: 'GET',
            url: '/authorization/group',
        }),
        false,
    )

    return (
        <EntityCombobox<AuthorizationGroupDto>
            dataPromise={groups}
            alphabetical
            getEntityLabel={group => group.name}
            getEntityValue={group => group.id}
            placeholderKey={'base.authorizationgroupcombobox.placeholder'}
            {...props}
        />
    )
}
